export const FLAG_GETTING_USER_LOCALES = 'FLAG_GETTING_USER_LOCALES';
export const GET_USER_LOCALES = 'GET_USER_LOCALES';
export const CLEAR_USER_LOCALES = 'CLEAR_USER_LOCALES';
